import * as React from 'react';

import _ from 'underscore';

import type {EntityListType} from 'nutshell-core/types';

import {ColumnPickerButton} from 'shells/button/column-picker-button/column-picker-button';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import {PaginationControls} from 'shells/pagination/pagination-controls';

import {ColumnPickerModal} from '../../entity-list/column-picker/column-picker-modal';

import styles from './entity-list-header.module.css';

type EntityListHeaderProps = {
    defaultFields: string[];
    selectedFields: string[];
    onPageChange: (arg1: number) => any;
    selectedPage: number;
    count: number;
    schema: any;
    onUpdateFields?: (arg1: string[]) => any;
    includeColumnPicker?: boolean;
    entityType: EntityListType;
    isLoading: boolean;
};

type EntityListHeaderState = {
    isColumnPickerOpen: boolean;
};

export class EntityListHeader extends React.Component<
    EntityListHeaderProps,
    EntityListHeaderState
> {
    static defaultProps = {
        selectedPage: 1,
    };

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            isColumnPickerOpen: false,
        };
    }

    render() {
        // Our urls previously had page default to 0, but we expect everything
        // to be 1-based index in pagination, so we'll adjust for that here
        //
        // @todo ccain remove page parameters from URL before saving to server
        const realSelectedPage = Math.max(this.props.selectedPage, 1);

        return (
            <div className={styles.container}>
                {this.props.isLoading ? (
                    <LoadingText height={16} width={150} />
                ) : (
                    <div className={styles['num-displayed']}>
                        {this.getShownRange(this.props.count, realSelectedPage)}
                    </div>
                )}
                <PaginationControls
                    totalPages={this.getTotalPages(this.props.count)}
                    selectedPage={realSelectedPage}
                    onPageChange={this.props.onPageChange}
                />
                {this.props.includeColumnPicker && this.props.entityType !== 'mcfxcompanies' ? (
                    // @ts-expect-error
                    <ColumnPickerButton onClick={this.handleColumnPickerOpen} />
                ) : undefined}
                <ColumnPickerModal
                    isOpen={this.state.isColumnPickerOpen}
                    onClose={this.handleColumnPickerClose}
                    schemaProperties={_.values(this.props.schema)}
                    selectedColumns={this.props.selectedFields}
                    entityType={this.props.entityType}
                    onResetFieldsToDefault={this.handleResetFields}
                    onUpdateFields={this.handleUpdateFields}
                />
            </div>
        );
    }

    handleColumnPickerOpen = () => {
        this.setState({isColumnPickerOpen: true});
    };

    handleColumnPickerClose = () => {
        this.setState({isColumnPickerOpen: false});
    };

    handleUpdateFields = (fields: string[]) => {
        if (this.props.onUpdateFields) {
            this.props.onUpdateFields(fields);
        }
    };

    handleResetFields = () => {
        if (this.props.onUpdateFields) {
            this.props.onUpdateFields(this.props.defaultFields);
        }
    };

    getTotalPages = (count: number) => {
        return Math.floor(count / 50) + 1;
    };

    getShownRange = (count: number, page: number) => {
        if (count === 0) {
            return '0 of 0';
        }

        let endOfRange = page * 50;
        if (this.getTotalPages(count) === page) {
            endOfRange = count;
        }

        return `${(page - 1) * 50 + 1}-${endOfRange} of ${count}`;
    };
}
